export default __webpack_public_path__ + "static/media/Mahanadi.c02e5669.webp";